import {
  generateMetricDay,
  generateMetricWeek,
  generateMetricMonth,
  generateMetricYear,
  generateDayData,
  generateWeekData,
  generateMonthData,
  generateYearData
} from "utils/generateAnalyticsData";

const busAnalytics = {
  busAnalytics: [
    {
      busNo: "1",
      busLicensePlateNo: "PB2586",
      generalStats: {
        day: {
          revenue: "$150K",
          avgFuelConsumed: "10Gal",
          avgRunningHours: "50Hrs",
          avgCO2Emission: "1.00T",
          avgPassengerCarried: "500",
        },
        weekly: {
          revenue: "$950K",
          avgFuelConsumed: "90Gal",
          avgRunningHours: "90Hrs",
          avgCO2Emission: "9.00T",
          avgPassengerCarried: "900",
        },
        monthly: {
          revenue: "$850K",
          avgFuelConsumed: "50Gal",
          avgRunningHours: "500Hrs",
          avgCO2Emission: "18.00T",
          avgPassengerCarried: "700",
        },
        yearly: {
          revenue: "$550K",
          avgFuelConsumed: "40Gal",
          avgRunningHours: "80Hrs",
          avgCO2Emission: "2.00T",
          avgPassengerCarried: "800",
        },
      },
      incomeStats: {
        day: {
          income: "$100K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$800K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$200K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$900K",

          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "1800",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "1900",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "1900",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2000",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "5 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "100 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateWeekData(1, 10),
        },
        monthly: {
          fuelConsumed: "200 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateMonthData(1, 15),
        },
        yearly: {
          fuelConsumed: "250 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateYearData(1, 20),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "20Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "30Hrs",

          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "3Hrs",

          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricWeek(1, 15, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "40Hrs",

          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "4Hrs",

          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricMonth(1, 15, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "50Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "5Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricMonth(1, 20, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.00T",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          emission: "3.00T",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "4.00T",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.00T",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "",
        day: {
          fuel: "60",
          maintenance: "40",
          others: "24",
          observation: "down",
          percentage: "3.0%",
        },
        weekly: {
          fuel: "70",
          maintenance: "60",
          others: "34",
          observation: "down",
          percentage: "3.0%",
        },
        monthly: {
          fuel: "100",
          maintenance: "40",
          others: "30",
          observation: "down",
          percentage: "3.0%",
        },
        yearly: {
          fuel: "120",
          maintenance: "58",
          others: "23",
          observation: "down",
          percentage: "3.0%",
        },
      },
    },
    {
      busNo: "2",
      busLicensePlateNo: "PB2593",
      generalStats: {
        day: {
          revenue: "$150K",
          avgFuelConsumed: "10Gal",
          avgRunningHours: "50Hrs",
          avgCO2Emission: "1.00T",
          avgPassengerCarried: "500",
        },
        weekly: {
          revenue: "$950K",
          avgFuelConsumed: "90Gal",
          avgRunningHours: "90Hrs",
          avgCO2Emission: "9.00T",
          avgPassengerCarried: "900",
        },
        monthly: {
          revenue: "$850K",
          avgFuelConsumed: "50Gal",
          avgRunningHours: "500Hrs",
          avgCO2Emission: "18.00T",
          avgPassengerCarried: "700",
        },
        yearly: {
          revenue: "$550K",
          avgFuelConsumed: "40Gal",
          avgRunningHours: "80Hrs",
          avgCO2Emission: "2.00T",
          avgPassengerCarried: "800",
        },
      },
      incomeStats: {
        day: {
          income: "$100K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$200K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$300K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$500K",

          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "1800",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "1800",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "1800",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "1800",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "5 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "5 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateWeekData(2.11),
        },
        monthly: {
          fuelConsumed: "5 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateMonthData(1, 15),
        },
        yearly: {
          fuelConsumed: "5 Gal",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateYearData(1, 9),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "20Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "30Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "40Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "50Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.0%",
          idleHours: "2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.5%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.00T",
          observation: "down",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          emission: "3.00T",

          observation: "down",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "4.00T",

          observation: "down",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.00T",

          observation: "down",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "1%",
        day: {
          fuel: "30",
          maintenance: "67",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "45",
          maintenance: "34",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "34",
          others: "26",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "25",
          maintenance: "56",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "3",
      busLicensePlateNo: "PB2587",
      generalStats: {
        day: {
          revenue: "$160K",
          avgFuelConsumed: "11Gal",
          avgRunningHours: "52Hrs",
          avgCO2Emission: "1.10T",
          avgPassengerCarried: "520",
        },
        weekly: {
          revenue: "$960K",
          avgFuelConsumed: "92Gal",
          avgRunningHours: "92Hrs",
          avgCO2Emission: "9.20T",
          avgPassengerCarried: "920",
        },
        monthly: {
          revenue: "$860K",
          avgFuelConsumed: "52Gal",
          avgRunningHours: "520Hrs",
          avgCO2Emission: "18.20T",
          avgPassengerCarried: "720",
        },
        yearly: {
          revenue: "$560K",
          avgFuelConsumed: "42Gal",
          avgRunningHours: "82Hrs",
          avgCO2Emission: "2.10T",
          avgPassengerCarried: "820",
        },
      },
      incomeStats: {
        day: {
          income: "$110K",
          observation: "up",
          percentage: "0.6%",
          analyticsData:
            generateMetricDay(),
        },
        weekly: {
          income: "$810K",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$210K",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$910K",
          observation: "up",
          percentage: "0.6%",
          analyticsData:
            generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "1850",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "1950",
          observation: "up",
          percentage: "3.1%",
          analyticsData:
            generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "1950",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2050",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "6 Gal",
          observation: "down",
          percentage: "0.6%",

          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "105 Gal",
          observation: "down",
          percentage: "0.6%",
          analyticsData: generateWeekData(1, 8),
        },
        monthly: {
          fuelConsumed: "205 Gal",
          observation: "down",
          percentage: "0.6%",
          analyticsData:
            generateMonthData(1, 8),
        },
        yearly: {
          fuelConsumed: "255 Gal",
          observation: "down",
          percentage: "0.6%",
          analyticsData:
            generateYearData(1, 8),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "21Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.1%",
          idleHours: "2.1Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.6%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "31Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.1%",
          idleHours: "3.1Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.6%",
          analyticsData:
            generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "41Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.1%",
          idleHours: "4.1Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.6%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "51Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.1%",
          idleHours: "5.1Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.6%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.10T",
          observation: "down",
          percentage: "0.6%",

          analyticsData:
            generateDayData(),
        },
        weekly: {
          emission: "3.10T",
          observation: "down",
          percentage: "0.6%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "4.10T",
          observation: "down",
          percentage: "0.6%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.10T",
          observation: "down",
          percentage: "0.6%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "1%",
        day: {
          fuel: "30",
          maintenance: "31",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "45",
          maintenance: "34",
          others: "29",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "34",
          others: "20",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "25",
          maintenance: "51",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "4",
      busLicensePlateNo: "PB2588",
      generalStats: {
        day: {
          revenue: "$170K",
          avgFuelConsumed: "12Gal",
          avgRunningHours: "54Hrs",
          avgCO2Emission: "1.20T",
          avgPassengerCarried: "540",
        },
        weekly: {
          revenue: "$970K",
          avgFuelConsumed: "94Gal",
          avgRunningHours: "94Hrs",
          avgCO2Emission: "9.40T",
          avgPassengerCarried: "940",
        },
        monthly: {
          revenue: "$870K",
          avgFuelConsumed: "54Gal",
          avgRunningHours: "540Hrs",
          avgCO2Emission: "18.40T",
          avgPassengerCarried: "740",
        },
        yearly: {
          revenue: "$570K",
          avgFuelConsumed: "44Gal",
          avgRunningHours: "84Hrs",
          avgCO2Emission: "2.20T",
          avgPassengerCarried: "840",
        },
      },
      incomeStats: {
        day: {
          income: "$120K",
          observation: "up",
          percentage: "0.7%",
          analyticsData:
            generateMetricDay(),
        },
        weekly: {
          income: "$820K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$220K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$920K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "1900",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "2000",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "2000",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2100",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "7 Gal",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "110 Gal",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateWeekData(1, 8),
        },
        monthly: {
          fuelConsumed: "210 Gal",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateMonthData(1, 8),
        },
        yearly: {
          fuelConsumed: "260 Gal",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateYearData(1, 8),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "22Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.2%",
          idleHours: "2.2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.7%",
          analyticsData:
            generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "32Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.2%",
          idleHours: "3.2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.7%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "42Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.2%",
          idleHours: "4.2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.7%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "52Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.2%",
          idleHours: "5.2Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.7%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.20T",
          observation: "down",
          percentage: "0.7%",

          analyticsData: generateDayData(),
        },
        weekly: {
          emission: "3.20T",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "4.20T",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.20T",
          observation: "down",
          percentage: "0.7%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "2%",
        day: {
          fuel: "30",
          maintenance: "67",
          others: "30",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "45",
          maintenance: "38",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "34",
          others: "29",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "27",
          maintenance: "56",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "5",
      busLicensePlateNo: "PB2589",
      generalStats: {
        day: {
          revenue: "$180K",
          avgFuelConsumed: "13Gal",
          avgRunningHours: "56Hrs",
          avgCO2Emission: "1.30T",
          avgPassengerCarried: "560",
        },
        weekly: {
          revenue: "$980K",
          avgFuelConsumed: "96Gal",
          avgRunningHours: "96Hrs",
          avgCO2Emission: "9.60T",
          avgPassengerCarried: "960",
        },
        monthly: {
          revenue: "$880K",
          avgFuelConsumed: "56Gal",
          avgRunningHours: "560Hrs",
          avgCO2Emission: "18.60T",
          avgPassengerCarried: "760",
        },
        yearly: {
          revenue: "$580K",
          avgFuelConsumed: "46Gal",
          avgRunningHours: "86Hrs",
          avgCO2Emission: "2.30T",
          avgPassengerCarried: "860",
        },
      },
      incomeStats: {
        day: {
          income: "$130K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$830K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$230K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$930K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "1950",
          observation: "up",
          percentage: "3.3%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "2050",
          observation: "up",
          percentage: "3.3%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "2050",
          observation: "up",
          percentage: "3.3%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2150",
          observation: "up",
          percentage: "3.3%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "8 Gal",
          observation: "down",
          percentage: "0.8%",

          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "115 Gal",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateWeekData(1, 8),
        },
        monthly: {
          fuelConsumed: "215 Gal",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateMonthData(1, 8),
        },
        yearly: {
          fuelConsumed: "265 Gal",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateYearData(1, 8),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "23Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.3%",
          idleHours: "2.3Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.8%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "33Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.3%",
          idleHours: "3.3Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.8%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "43Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.3%",
          idleHours: "4.3Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.8%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "53Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.3%",
          idleHours: "5.3Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.8%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.30T",
          observation: "down",
          percentage: "0.8%",

          analyticsData: generateDayData(),
        },
        weekly: {
          emission: "3.30T",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "4.30T",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.30T",
          observation: "down",
          percentage: "0.8%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "4%",
        day: {
          fuel: "30",
          maintenance: "89",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "45",
          maintenance: "91",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "34",
          others: "29",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "28",
          maintenance: "56",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "6",
      busLicensePlateNo: "PB2590",
      generalStats: {
        day: {
          revenue: "$190K",
          avgFuelConsumed: "14Gal",
          avgRunningHours: "58Hrs",
          avgCO2Emission: "1.40T",
          avgPassengerCarried: "580",
        },
        weekly: {
          revenue: "$990K",
          avgFuelConsumed: "98Gal",
          avgRunningHours: "98Hrs",
          avgCO2Emission: "9.80T",
          avgPassengerCarried: "980",
        },
        monthly: {
          revenue: "$890K",
          avgFuelConsumed: "58Gal",
          avgRunningHours: "580Hrs",
          avgCO2Emission: "18.80T",
          avgPassengerCarried: "780",
        },
        yearly: {
          revenue: "$590K",
          avgFuelConsumed: "48Gal",
          avgRunningHours: "88Hrs",
          avgCO2Emission: "2.40T",
          avgPassengerCarried: "880",
        },
      },
      incomeStats: {
        day: {
          income: "$140K",
          observation: "up",
          percentage: "0.9%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$840K",
          observation: "up",
          percentage: "0.9%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$240K",
          observation: "up",
          percentage: "0.9%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$940K",
          observation: "up",
          percentage: "0.9%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "2000",
          observation: "up",
          percentage: "3.4%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "2100",
          observation: "up",
          percentage: "3.4%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "2100",
          observation: "up",
          percentage: "3.4%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2200",
          observation: "up",
          percentage: "3.4%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "9 Gal",
          observation: "down",
          percentage: "0.9%",

          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "120 Gal",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateWeekData(2, 9),
        },
        monthly: {
          fuelConsumed: "220 Gal",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateMonthData(1, 9),
        },
        yearly: {
          fuelConsumed: "270 Gal",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateYearData(2, 9),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "24Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.4%",
          idleHours: "2.4Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.9%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "34Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.4%",
          idleHours: "3.4Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.9%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "44Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.4%",
          idleHours: "4.4Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.9%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "54Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.4%",
          idleHours: "5.4Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "0.9%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.40T",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateDayData(),
        },
        weekly: {
          emission: "3.40T",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          emission: "5.40T",

          observation: "down",
          percentage: "0.9%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          emission: "5.40T",
          observation: "down",
          percentage: "0.9%",
          analyticsData: generateYearData(),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "1%",
        day: {
          fuel: "39",
          maintenance: "67",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "49",
          maintenance: "34",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "39",
          others: "26",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "25",
          maintenance: "51",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "7",
      busLicensePlateNo: "PB2591",
      generalStats: {
        day: {
          revenue: "$200K",
          avgFuelConsumed: "15Gal",
          avgRunningHours: "60Hrs",
          avgCO2Emission: "1.50T",
          avgPassengerCarried: "600",
        },
        weekly: {
          revenue: "$1.0M",
          avgFuelConsumed: "100Gal",
          avgRunningHours: "100Hrs",
          avgCO2Emission: "10.00T",
          avgPassengerCarried: "1000",
        },
        monthly: {
          revenue: "$900K",
          avgFuelConsumed: "60Gal",
          avgRunningHours: "600Hrs",
          avgCO2Emission: "19.00T",
          avgPassengerCarried: "800",
        },
        yearly: {
          revenue: "$600K",
          avgFuelConsumed: "50Gal",
          avgRunningHours: "90Hrs",
          avgCO2Emission: "2.50T",
          avgPassengerCarried: "900",
        },
      },
      incomeStats: {
        day: {
          income: "$150K",
          observation: "up",
          percentage: "1.0%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$850K",
          observation: "up",
          percentage: "1.0%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$250K",
          observation: "up",
          percentage: "1.0%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$950K",
          observation: "up",
          percentage: "1.0%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "2050",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "2150",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "2150",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2250",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "10 Gal",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "125 Gal",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateWeekData(2, 9),
        },
        monthly: {
          fuelConsumed: "225 Gal",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateMonthData(1, 8),
        },
        yearly: {
          fuelConsumed: "275 Gal",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateYearData(2, 8),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "25Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.5%",
          idleHours: "2.5Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.0%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "35Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.5%",
          idleHours: "3.5Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.0%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "45Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.5%",
          idleHours: "4.5Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.0%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "55Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.5%",
          idleHours: "5.5Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.0%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.50T",
          observation: "down",
          percentage: "1.0%",

          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          emission: "3.50T",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateWeekData(1, 9),
        },
        monthly: {
          emission: "4.50T",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateMonthData(1, 7),
        },
        yearly: {
          emission: "5.50T",
          observation: "down",
          percentage: "1.0%",
          analyticsData: generateYearData(1, 9),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "5%",
        day: {
          fuel: "38",
          maintenance: "67",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "45",
          maintenance: "39",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "23",
          maintenance: "31",
          others: "26",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "29",
          maintenance: "56",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
    {
      busNo: "8",
      busLicensePlateNo: "PB2592",
      generalStats: {
        day: {
          revenue: "$210K",
          avgFuelConsumed: "16Gal",
          avgRunningHours: "62Hrs",
          avgCO2Emission: "1.60T",
          avgPassengerCarried: "620",
        },
        weekly: {
          revenue: "$1.1M",
          avgFuelConsumed: "102Gal",
          avgRunningHours: "102Hrs",
          avgCO2Emission: "10.20T",
          avgPassengerCarried: "1020",
        },
        monthly: {
          revenue: "$910K",
          avgFuelConsumed: "62Gal",
          avgRunningHours: "620Hrs",
          avgCO2Emission: "19.20T",
          avgPassengerCarried: "820",
        },
        yearly: {
          revenue: "$610K",
          avgFuelConsumed: "52Gal",
          avgRunningHours: "92Hrs",
          avgCO2Emission: "2.60T",
          avgPassengerCarried: "920",
        },
      },
      incomeStats: {
        day: {
          income: "$160K",
          observation: "up",
          percentage: "1.1%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          income: "$860K",
          observation: "up",
          percentage: "1.1%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          income: "$260K",
          observation: "up",
          percentage: "1.1%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          income: "$960K",
          observation: "up",
          percentage: "1.1%",
          analyticsData: generateMetricYear(),
        },
      },
      distanceTravelledStats: {
        day: {
          totalDistanceTravelled: "2100",
          observation: "up",
          percentage: "3.6%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceTravelled: "2200",
          observation: "up",
          percentage: "3.6%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceTravelled: "2200",
          observation: "up",
          percentage: "3.6%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceTravelled: "2300",
          observation: "up",
          percentage: "3.6%",
          analyticsData: generateYearData(),
        },
      },
      fuelConsumedStats: {
        day: {
          fuelConsumed: "11 Gal",
          observation: "down",
          percentage: "1.1%",

          analyticsData: generateDayData(1, 8),
        },
        weekly: {
          fuelConsumed: "130 Gal",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateWeekData(1, 8),
        },
        monthly: {
          fuelConsumed: "230 Gal",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateMonthData(2, 9),
        },
        yearly: {
          fuelConsumed: "280 Gal",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateYearData(1, 9),
        },
      },
      travellingHoursStats: {
        day: {
          runningHours: "26Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.6%",
          idleHours: "2.6Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.1%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          runningHours: "36Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.6%",
          idleHours: "3.6Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.1%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          runningHours: "46Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.6%",
          idleHours: "4.6Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.1%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          runningHours: "56Hrs",
          runningHrsObservation: "up",
          runningHrsPercentage: "1.6%",
          idleHours: "5.6Hrs",
          idleHrsObservation: "down",
          idleHrsPercentage: "1.1%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      co2EmissionStats: {
        day: {
          emission: "2.60T",
          observation: "down",
          percentage: "1.1%",

          analyticsData: generateDayData(1, 9),
        },
        weekly: {
          emission: "3.60T",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateWeekData(1, 8),
        },
        monthly: {
          emission: "4.60T",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateMonthData(1, 9),
        },
        yearly: {
          emission: "5.60T",
          observation: "down",
          percentage: "1.1%",
          analyticsData: generateYearData(1, 8),
        },
      },
      expensesStats: {
        observation: "up",
        percentage: "2%",
        day: {
          fuel: "32",
          maintenance: "67",
          others: "34",
          observation: "down",
          percentage: "2%",
        },
        weekly: {
          fuel: "41",
          maintenance: "34",
          others: "23",
          observation: "down",
          percentage: "3%",
        },
        monthly: {
          fuel: "29",
          maintenance: "34",
          others: "26",
          observation: "down",
          percentage: "2%",
        },
        yearly: {
          fuel: "25",
          maintenance: "59",
          others: "34",
          observation: "down",
          percentage: "3%",
        },
      },
    },
  ],
  overAllAnalytics: {
    generalStats: {
      day: {
        revenue: "$90K",
        avgFuelConsumed: "200 Gal",
        avgRunningHours: "10Hrs",
        avgCO2Emission: "7.00T",
        avgPassengerCarried: "500",
      },
      weekly: {
        revenue: "$950K",
        avgFuelConsumed: "90Gal",
        avgRunningHours: "90Hrs",
        avgCO2Emission: "9.00T",
        avgPassengerCarried: "900",
      },
      monthly: {
        revenue: "$850K",
        avgFuelConsumed: "50Gal",
        avgRunningHours: "500Hrs",
        avgCO2Emission: "18.00T",
        avgPassengerCarried: "700",
      },
      yearly: {
        revenue: "$550K",
        avgFuelConsumed: "40Gal",
        avgRunningHours: "80Hrs",
        avgCO2Emission: "2.00T",
        avgPassengerCarried: "800",
      },
    },
    incomeStats: {
      day: {
        avgIncome: "$90K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricDay(),
      },
      weekly: {
        avgIncome: "$950K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricWeek(),
      },
      monthly: {
        avgIncome: "$90K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricMonth(),
      },
      yearly: {
        avgIncome: "$90K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricYear(),
      },
    },
    distanceTravelledStats: {
      day: {
        avgDistanceTravelled: "1524",
        observation: "down",
        percentage: "3.0%",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgDistanceTravelled: "1524",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgDistanceTravelled: "1524",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgDistanceTravelled: "1524",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateYearData(),
      },
    },
    fuelConsumedStats: {
      day: {
        avgFuelConsumed: "90 Gal",
        observation: "down",
        percentage: "0.5%",

        analyticsData: generateDayData(1, 8),
      },
      weekly: {
        avgFuelConsumed: "200 Gal",
        observation: "down",
        percentage: "0.5%",
        analyticsData: generateWeekData(1, 8),
      },
      monthly: {
        avgFuelConsumed: "200 Gal",
        observation: "down",
        percentage: "0.5%",
        analyticsData: generateMonthData(1, 8),
      },
      yearly: {
        avgFuelConsumed: "200 Gal",
        observation: "down",
        percentage: "0.5%",
        analyticsData: generateYearData(1, 8),
      },
    },
    travellingHoursStats: {
      day: {
        avgRunningHours: "90Hrs",
        runningHrsObservation: "up",
        runningHrsPercentage: "1.0%",

        avgIdleHours: "2Hrs",
        idleHrsObservation: "down",
        idleHrsPercentage: "0.5%",
        analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
      },
      weekly: {
        avgRunningHours: "15Hrs",
        runningHrsObservation: "up",
        runningHrsPercentage: "1.0%",

        avgIdleHours: "2Hrs",
        idleHrsObservation: "down",
        idleHrsPercentage: "0.5%",
        analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
      },
      monthly: {
        avgRunningHours: "10Hrs",
        runningHrsObservation: "up",
        runningHrsPercentage: "1.0%",

        avgIdleHours: "2Hrs",
        idleHrsObservation: "down",
        idleHrsPercentage: "0.5%",
        analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
      },
      yearly: {
        avgRunningHours: "10Hrs",
        runningHrsObservation: "up",
        runningHrsPercentage: "1.0%",

        avgIdleHours: "2Hrs",
        idleHrsObservation: "down",
        idleHrsPercentage: "0.5%",
        analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
      },
    },
    co2EmissionStats: {
      day: {
        avgEmission: "9.00T",

        observation: "down",
        percentage: "0.5%",

        analyticsData: generateDayData(),
      },
      weekly: {
        avgEmission: "7.00T",

        observation: "down",
        percentage: "0.5%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgEmission: "7.00T",

        observation: "down",
        percentage: "0.5%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgEmission: "7.00T",

        observation: "down",
        percentage: "0.5%",
        analyticsData: generateYearData(),
      },
    },
    expensesStats: {
      observation: "up",
      percentage: "1%",
      day: {
        fuel: "31",
        maintenance: "68",
        others: "35",
        observation: "down",
        percentage: "2%",
      },
      weekly: {
        fuel: "46",
        maintenance: "34",
        others: "23",
        observation: "down",
        percentage: "3%",
      },
      monthly: {
        fuel: "24",
        maintenance: "34",
        others: "26",
        observation: "down",
        percentage: "2%",
      },
      yearly: {
        fuel: "28",
        maintenance: "56",
        others: "34",
        observation: "down",
        percentage: "3%",
      },
    },
  },
};
export default busAnalytics;
